<!-- Vollzeitäquivalent -->
<p-panel [header]="'fs.res.researchInfrastructure.fullTimePercentage'|hisUi">
    <div class="infoMessage" [innerHTML]="'fs.res.researchInfrastructure.ResearchInfrastructureEmployment.fullTimePercentageInformation' | hisUi"></div>
    <br/>
    <his-plam>
        <input #content hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructureEmployment.fullTimePercentage" class="inputWidth100" type="number"
            [(ngModel)]="researchInfrastructureEmployment.fullTimePercentage" />
    </his-plam>
</p-panel>

<!-- Zeitraum -->
<p-panel [header]="'fs.res.researchInfrastructure.period'|hisUi">
    <his-plam>
        <p-calendar #content styleClass="calendarWidth100" appendTo="body"
            hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructureEmployment.validFrom"
            [(ngModel)]="researchInfrastructureEmployment.validFrom"
            [maxDate]="maxDateValidTo">
     </p-calendar>
    </his-plam>
    
    <his-plam>
        <p-calendar #content styleClass="calendarWidth100" appendTo="body"
            hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructureEmployment.validTo"
            [(ngModel)]="researchInfrastructureEmployment.validTo"
            [minDate]="maxDateValidFrom">
        </p-calendar>
    </his-plam>
</p-panel>